import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./MicrosoftAuthConfig";

export const msalInstance = new PublicClientApplication(msalConfig);
